import axios from "axios";

const API = axios.create({
  baseURL: "http://66.116.243.168:5000/api"
});

API.interceptors.request.use((req) => {
  const noatoken = localStorage.getItem("noatoken");
  if (noatoken) req.headers.Authorization = `Bearer ${noatoken}`;
  return req;
});

export default API;
